import classnames from 'classnames';

import css from '@styles/catalogFilters';

function FilterRadioItem({
  label,
  image,
  inputValue,
  onChange,
  selected,
  htmlName,
  htmlId
}) {
  return (
    <li>
      <input
        type='radio'
        value={inputValue}
        onChange={onChange}
        checked={selected}
        name={htmlName}
        id={htmlId}
      />

      <label
        htmlFor={htmlId}
        className={classnames(css.filterLabel, {
          [css.checkedFilterLabel]: selected
        })}
      >
        {label}
      </label>
    </li>
  );
}

export default FilterRadioItem;
